import React, { Component } from "react";
import { CollaborationBar } from "./collaborationBar";

export class CollaborationBarContainer extends Component {
  state = {
      showComments: true,
      showAssignUser: true,
      showCollaboration: true,
  }

  onShowSlideGrid = () => {
      this.setState({
          showComments: false,
          showAssignUser: false,
          showCollaboration: false
      });
  }

  onHideSlideGrid =() => {
      this.setState({
          showComments: true,
          showAssignUser: true,
          showCollaboration: true
      });
  }

  render() {
      const { showAssignUser, showCollaboration, showComments } = this.state;
      return (<CollaborationBar showComments={showComments}
          showAssignUser={showAssignUser} showCollaboration={showCollaboration} />);
  }
}
